import React, { useEffect, useState } from "react";
import OrderLinesTable, { LineTag } from "../../../../components/Orders/OrderLinesTable";
import axios from "axios";
import moment from "moment";
import {
  Container,
  Card,
  Row,
  Col,
  Button,
  Spinner,
  Alert,
  Form,
  Modal,
  ProgressBar,
} from "react-bootstrap";
import { withStyles } from "@material-ui/core/styles";
import { FormControlLabel, Switch, Badge, Chip } from "@material-ui/core";
import { useParams, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { io } from "socket.io-client";
import {
  MdCancel,
  MdLocalPrintshop,
  MdArrowBackIosNew,
  MdOutlineCreditCardOff,
  MdOutlineCreditCard,
  MdMap,
  MdRefresh,
  MdLocationOn,
  MdStorefront,
  MdAnalytics,
  // MdDirections,
  MdWarning,
  // MdRadar,
  MdShoppingCart,
  MdDescription,
  MdPerson,
  MdShowChart,
  MdLocalHospital,
  MdVerifiedUser,
  MdLocalShipping,
  MdUndo,
} from "react-icons/md";
import { toast } from "react-toastify";
import {
  assignRestaurantOrderToDeliveryAgent,
  getOrderDetailsToProcess,
  markOrderAsPaid,
  re_assignRestaurantOrderToDeliveryAgent,
  updateRestaurantOrderDeliveryStatus,
} from "../../../../actions/webOrderActions";
import { RESET_UPDATE_DELIVERY_STATUS_COMPLETE } from "../../../../constants/webOrderConstants";
import "./RestaurantOrderDetails.css";
import { getUserFromLocalStorage } from "../../../../utilities/user.js";
import RiderSelectionDropdown from "./RiderSelectionDropdown";
import { isRiderAssignmentLocked } from "../../../../utilities/orderRiderLock";
import ThreePLPartnerDropdown from "../../../../components/ThreePLPartnerDropdown";
import CancelOrderFields, { useCancellationReason, CancellationRecord } from "../../../../components/Orders/CancelOrderFields";
import ContactAction from "../../../../components/Orders/ContactAction";
import DropoffMap from "../../../../components/Maps/DropoffMap";
import VendorHandoffActions from "../../../../components/Orders/VendorHandoffActions";
import { getShippingAddressText } from "../../../../utilities/orderPresentation";
import { openReceiptForPrint } from "../../../../utilities/openReceipt";
import OrderNextStep from "../../../../components/Orders/OrderNextStep";
import socketAuthOptions from "../../../../utilities/socketAuth";
import { attachVendorOrderRooms } from "../../../../hooks/useVendorOrderRooms";
import { orderLocationKeyOf, orderLocationName, vendorOwnerIdOf } from "../../../../utilities/vendorScope";
import { useBranchScope } from "../../../../context/BranchScopeContext";
import useOrderLiveUpdates from "../../../../hooks/useOrderLiveUpdates";
import {
  getDeliveryProgress,
  canVendorDispatch,
  canVendorMarkDelivered,
} from "../../../../utilities/orderDeliverySteps";
import { useGate } from "../../../../components/team/Gated";
import AppSelect from "../../../../components/ui/AppSelect";

const API_URL = process.env.REACT_APP_SERVER_URL;

const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    "&$checked": {
      transform: "translateX(16px)",
      color: theme.palette.common.white,
      "& + $track": {
        backgroundColor: "#52d869",
        opacity: 1,
        border: "none",
      },
    },
    "&$focusVisible $thumb": {
      color: "#52d869",
      border: "6px solid #fff",
    },
  },
  thumb: {
    width: 24,
    height: 24,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

const isDevelopment = process.env.NODE_ENV === "development";

const HealthcareVendorOrderDetails = () => {
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const user = getUserFromLocalStorage();

  const [showCancelModal, setShowCancelModal] = useState(false);
  // Reason + note for the audit record. Required by the server on cancel.
  const cancelReason = useCancellationReason();
  const [riders, setRiders] = useState([]);
  const [riderId, setRiderId] = useState("");
  // Vendor team permissions: every status, dispatch, rider and 3PL change
  // on this page is orders:manage (components/team/Gated.js).
  const ordersGate = useGate("orders:manage");
  // Which pharmacy branch the order is at (4 Oct 2026), shown when the
  // pharmacy has branches; orders from before branches read as the main one.
  const { hasBranches, nameOf } = useBranchScope();
  const [loadingRiders, setLoadingRiders] = useState(true);
  const [assignedRider, setAssignedRider] = useState(null);
  const [elapsedAssignedTime, setElapsedAssignedTime] = useState(0);
  const [elapsedDispatchedTime, setElapsedDispatchedTime] = useState(0);
  const [showMapModal, setShowMapModal] = useState(false);
  const [showPrescriptionModal, setShowPrescriptionModal] = useState(false);

  // Healthcare-specific state
  const [hasAgeRestriction, setHasAgeRestriction] = useState(false);
  const [maxAgeRestriction, setMaxAgeRestriction] = useState(0);
  const [hasControlledSubstance, setHasControlledSubstance] = useState(false);
  const [requiresPrescription, setRequiresPrescription] = useState(false);

  // 3PL Partner assignment state
  const [assignmentMode, setAssignmentMode] = useState("rider"); // "rider" or "3pl"
  const [selectedPartnerId, setSelectedPartnerId] = useState("");
  const [assigning3PL, setAssigning3PL] = useState(false);
  const [recalling3PL, setRecalling3PL] = useState(false);
  const [showRecallModal, setShowRecallModal] = useState(false);
  const [autoAssigning, setAutoAssigning] = useState(false);
  const [autoAssignEnabled, setAutoAssignEnabled] = useState(false);

  const mobileOrderDeliver = useSelector((state) => state.mobileOrderDeliver);
  const { loading: loadingDeliver, success: successDeliver } =
    mobileOrderDeliver;

  const orderDetails = useSelector((state) => state.orderDetails);
  const {
    order,
    loading,
    error,
    isUpdateDeliveryStatusComplete,
    paymentResult,
  } = orderDetails;

  // Live order news (a rider's pickup, a 3PL delivery, a decline) through the
  // one shared feed; see hooks/useOrderLiveUpdates.js. The page-level
  // listeners this replaces put `{ _id, delivery_status }` in the store as
  // the whole order, blanking the items.
  useOrderLiveUpdates(id, {
    onChange: (fresh) => {
      if (fresh?.delivery_status === "PROCESSING" && !fresh?.riderId) setRiderId("");
    },
  });

  const [isDataLoaded, setIsDataLoaded] = useState(false);

  useEffect(() => {
    if (!id) return;
    dispatch(getOrderDetailsToProcess(id));
  }, [id, dispatch]);

  useEffect(() => {
    if (isUpdateDeliveryStatusComplete) {
      dispatch({ type: RESET_UPDATE_DELIVERY_STATUS_COMPLETE });
    }
  }, [isUpdateDeliveryStatusComplete, dispatch]);

  useEffect(() => {
    if (order?.riderId) {
      setRiderId(
        typeof order.riderId === "object" ? order.riderId._id : order.riderId
      );
    }
  }, [order?.riderId]);

  // Check for healthcare-specific requirements
  useEffect(() => {
    if (order && order.orderItems) {
      let ageRestriction = false;
      let maxAge = 0;
      let controlledSubstance = false;
      let prescription = false;

      order.orderItems.forEach((item) => {
        if (item.ageRestriction && item.ageRestriction > 0) {
          ageRestriction = true;
          if (item.ageRestriction > maxAge) {
            maxAge = item.ageRestriction;
          }
        }
        if (item.controlledSubstance) {
          controlledSubstance = true;
        }
        if (item.requiresPrescription) {
          prescription = true;
        }
      });

      setHasAgeRestriction(ageRestriction);
      setMaxAgeRestriction(maxAge);
      setHasControlledSubstance(controlledSubstance);
      setRequiresPrescription(prescription);
    }
  }, [order]);

  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);

  useEffect(() => {
    if (order?.riderId && riders.length) {
      setAssignedRider(riders.find((rider) => rider._id === order.riderId._id));
    }
  }, [order, riders]);

  useEffect(() => {
    if (order && order.orderItems && order.orderItems.length > 0) {
      setIsDataLoaded(true);
    }
  }, [order]);

  const socketUrl = process.env.REACT_APP_SERVER_URL;

  useEffect(() => {
    // Authenticated: without a token the server treats this socket as
    // anonymous, and every gated handler (joinVendorRoom, getRiders scoping)
    // silently refuses. See utilities/socketAuth.js.
    const socket = io(
      socketUrl,
      socketAuthOptions({ userId: user?.result?._id })
    );

    socket.on("connect", () => {
      if (isDevelopment) {
        console.log("Webclient Connected");
      }
      socket.emit("getRiders");
    });

    // The vendor's order rooms carry the auto-assign feedback. One join that
    // names the owner; the server picks the whole business or this member's
    // branches (4 Oct 2026).
    const ownerId = vendorOwnerIdOf(user);
    const stopRooms = attachVendorOrderRooms(socket, ownerId, {
      fallback: (s) => s.emit("joinVendorRoom", ownerId),
    });

    socket.on("initialRidersList", (socketData) => {
      setRiders(socketData);
      setLoadingRiders(false);
    });

    socket.on("updatedRidersList", (updatedRiders) => {
      setRiders(updatedRiders);
    });

    socket.on("riderAdded", (newRider) => {
      setRiders((prevRiders) => [...prevRiders, newRider]);
    });

    socket.on("riderUpdated", (updatedRider) => {
      setRiders((prevRiders) =>
        prevRiders.map((rider) =>
          rider._id === updatedRider._id ? updatedRider : rider
        )
      );
    });

    socket.on("riderDeleted", (deletedRider) => {
      setRiders((prevRiders) =>
        prevRiders.filter((rider) => rider._id !== deletedRider._id)
      );
    });

    // Auto-assign feedback — only process events for the current order
    socket.on("autoAssign:assigned", (data) => {
      if (data.orderId !== id) return;
      setAutoAssigning(false);
      setAutoAssignEnabled(false);
      const riderName = data.riderName || "a rider";
      toast.success(`Order auto-assigned to ${riderName}`);
      dispatch(getOrderDetailsToProcess(id));
    });

    socket.on("autoAssign:result", (data) => {
      if (data.orderId !== id) return;
      setAutoAssigning(false);
      setAutoAssignEnabled(false);
      if (data.status === "exhausted" || data.status === "no_riders") {
        toast.warn("No available in-house riders found. Please assign manually.");
      }
    });

    return () => {
      stopRooms();
      socket.disconnect();
    };
  }, [user?.result?._id, dispatch, id]);

  const handleBack = () => {
    // Navigate back to appropriate orders page based on user role
    const isSuperAdmin = user?.result?.user_role === "SUPERUSER" || user?.result?.userType === "LUSUKU STAFF";

    if (isSuperAdmin) {
      history.push("/admin/paginatedOrdersTable");
    } else {
      history.push("/admin/healthcare-orders");
    }
  };

  const handleUpdateStatus = (newStatus) => {
    if (newStatus === "ASSIGNED" && !riderId) {
      toast.warn("Please select a rider before assigning the order.");
      return;
    }
    if (newStatus === "ASSIGNED") {
      assignHealthcareOrderToRider();
    } else {
      dispatch(updateRestaurantOrderDeliveryStatus(order?._id, newStatus));
    }
  };

  const handleCancelOrder = () => {
    // Refuse locally too, so the modal explains itself instead of
    // bouncing off a 400 from the server.
    if (!cancelReason.validate()) return;
    const delivery_status = "REJECTED";
    // 
    dispatch(updateRestaurantOrderDeliveryStatus(order?._id, delivery_status, cancelReason.payload()));
    setShowCancelModal(false);
    cancelReason.reset();
  };

  // Print Receipt opens the receipt document (the one with the fiscal
  // markings when issued), not a print of this page.
  const handlePrint = () => openReceiptForPrint(order?._id);

  const handleMarkAsPaid = () => {
    if (user?.result?.userType !== "LUSUKU STAFF" && user?.result?.user_role !== "SUPERUSER") {
      toast.warn("🚫 You are not authorized to mark order as paid!");
      return;
    } else if (order?.isPaid) {
      toast.info("This order is already marked as paid.");
      return;
    } else {
      dispatch(markOrderAsPaid(order?._id));
    }
  };

  // Trigger vendor auto-assignment using in-house riders
  const handleVendorAutoAssign = async () => {
    const vendorId = vendorOwnerIdOf(user);
    if (!vendorId) {
      toast.warn("Vendor ID not found");
      setAutoAssignEnabled(false);
      return;
    }
    setAutoAssigning(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${API_URL}/weborders/${order?._id}/vendor-auto-assign`,
        { vendorId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data.success) {
        toast.success("Auto-assigning to nearest available rider…");
        setTimeout(() => dispatch(getOrderDetailsToProcess(order?._id)), 4000);
      } else {
        toast.error(response.data.error?.message || "Auto-assign failed");
        setAutoAssignEnabled(false);
      }
    } catch (error) {
      toast.error(
        error.response?.data?.error?.message || "Failed to trigger auto-assign"
      );
      setAutoAssignEnabled(false);
    } finally {
      setAutoAssigning(false);
    }
  };

  const assignHealthcareOrderToRider = () => {
    const delivery_status = "ASSIGNED";
    const assignedTime = Date.now();
    const selectedRider = riders.find(r => r._id === riderId);
    const isCodFlagged = selectedRider?.codCash?.isFlagged === true;
    toast.success(`Assigning order ${order?._id} to rider ${riderId}`);
    localStorage.setItem(`order_${order?._id}_assignedTime`, assignedTime);
    dispatch(
      assignRestaurantOrderToDeliveryAgent(order?._id, riderId, delivery_status, isCodFlagged)
    );
  };

  const handleDispatchHealthcareOrder = () => {
    const delivery_status = "DISPATCHED";
    const dispatchedTime = Date.now();
    // console.log(`Dispatching order ${order?._id}`);
    localStorage.setItem(`order_${order?._id}_dispatchedTime`, dispatchedTime);
    dispatch(updateRestaurantOrderDeliveryStatus(order?._id, delivery_status));
    setTimeout(() => {
      dispatch(getOrderDetailsToProcess(order?._id));
    }, 500);
  };

  const handleDeliverHealthcareOrder = () => {
    const delivery_status = "DELIVERED";
    dispatch(updateRestaurantOrderDeliveryStatus(order?._id, delivery_status));
    setTimeout(() => {
      dispatch(getOrderDetailsToProcess(order?._id));
    }, 500);
  };

  // The delivery ladder lives in utilities/orderDeliverySteps.js so this page,
  // its sibling vendor pages and the next-step banner can never disagree about
  // where an order is. This was a four-case switch whose `default: 0` emptied
  // the bar for the six statuses this page never writes itself: ACCEPTED and
  // PICKED_UP come from the rider app (OrderDetailsScreen / DispatchOrderScreen),
  // PENDING_3PL / IN_TRANSIT / ARRIVED from the 3PL rail, FULFILLED from the
  // counter. A rider tapping Accept therefore made the vendor's screen look
  // like the order had gone backwards to zero.
  //
  // NOTE: there is no "PAID" delivery_status. Payment state lives in
  // `isPaid`/`paymentStatus` (see utilities/paymentStatus.js); the
  // delivery_status enum in models/Orders.js has no such member.
  const getProgress = () => getDeliveryProgress(order);

  const getBadgeStyle = (status) => {
    switch (status) {
      case "PROCESSING":
        return {
          backgroundColor: "orange",
          color: "white",
          borderRadius: "10px",
          padding: "5px",
          width: "110px",
          height: "20px",
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
        };
      case "ASSIGNED":
        return {
          backgroundColor: "blue",
          color: "white",
          borderRadius: "10px",
          padding: "5px",
        };
      case "DISPATCHED":
        return {
          backgroundColor: "purple",
          color: "white",
          borderRadius: "10px",
          padding: "5px",
        };
      case "DELIVERED":
        return {
          backgroundColor: "green",
          color: "white",
          borderRadius: "10px",
          padding: "5px",
        };
      case "REJECTED":
        return {
          backgroundColor: "red",
          color: "white",
          borderRadius: "10px",
          padding: "5px",
        };
      default:
        return {
          backgroundColor: "grey",
          color: "white",
          borderRadius: "10px",
          padding: "5px",
        };
    }
  };

  const getPaidBadgeStyle = (isPaid) => {
    return {
      backgroundColor: isPaid ? "green" : "#2C3A40",
      color: "white",
      borderRadius: "10px",
      padding: "3px",
    };
  };

  // Only an order still in PROCESSING can be cancelled here. This used to also
  // accept a "PAID" delivery_status, which is not a member of the delivery_status
  // enum and could never be stored — dead code that made the rule look broader
  // than it is. Behaviour is unchanged.
  const canCancelOrder = order?.delivery_status === "PROCESSING";

  const getDisabledStatusOptions = () => {
    const disabledOptions = {
      PROCESSING: order?.delivery_status !== "PROCESSING",
      ASSIGNED:
        order?.delivery_status !== "PROCESSING" &&
        !canVendorDispatch(order),
      DISPATCHED:
        !canVendorDispatch(order) &&
        !canVendorMarkDelivered(order),
      DELIVERED:
        !canVendorMarkDelivered(order) &&
        order?.delivery_status !== "DELIVERED",
      REJECTED:
        order?.delivery_status === "DELIVERED" ||
        order?.delivery_status === "REJECTED",
    };
    return disabledOptions;
  };

  const disabledStatusOptions = getDisabledStatusOptions();

  useEffect(() => {
    if (order?.delivery_status === "ASSIGNED") {
      const storedAssignedTime = localStorage.getItem(
        `order_${order?._id}_assignedTime`
      );
      if (storedAssignedTime) {
        const elapsed = Math.floor(
          (Date.now() - parseInt(storedAssignedTime, 10)) / 1000
        );
        setElapsedAssignedTime(elapsed);
      }
    }
    if (order?.delivery_status === "DISPATCHED") {
      const storedDispatchedTime = localStorage.getItem(
        `order_${order?._id}_dispatchedTime`
      );
      if (storedDispatchedTime) {
        const elapsed = Math.floor(
          (Date.now() - parseInt(storedDispatchedTime, 10)) / 1000
        );
        setElapsedDispatchedTime(elapsed);
      }
    }

    const interval = setInterval(() => {
      if (order?.delivery_status === "ASSIGNED") {
        setElapsedAssignedTime((prev) => prev + 1);
      }
      if (order?.delivery_status === "DISPATCHED") {
        setElapsedDispatchedTime((prev) => prev + 1);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [order?.delivery_status, order?._id]);

  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;
    return distance.toFixed(2);
  };

  const handleReassignOrder = () => {
    const delivery_status = "PROCESSING";
    const currentRiderId =
      typeof order?.riderId === "object" ? order?.riderId?._id : order?.riderId;
    if (order?._id && currentRiderId) {
      dispatch(
        re_assignRestaurantOrderToDeliveryAgent(
          order?._id,
          currentRiderId,
          delivery_status,
          true
        )
      );
    } else {
      toast.error("No rider currently assigned to this order.");
    }
  };

  // Assign order to 3PL Partner
  const assignOrderTo3PLPartner = async () => {
    if (!selectedPartnerId) {
      toast.warn("Please select a 3PL partner");
      return;
    }

    setAssigning3PL(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${API_URL}/weborders/${order?._id}/assign-to-3pl`,
        { partnerId: selectedPartnerId },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.data.success) {
        toast.success(response.data.message || "Order assigned to 3PL partner!");
        dispatch(getOrderDetailsToProcess(order?._id));
      } else {
        toast.error(response.data.error?.message || "Failed to assign order");
      }
    } catch (error) {
      console.error("Error assigning to 3PL:", error);
      toast.error(
        error.response?.data?.error?.message || "Failed to assign to 3PL partner"
      );
    } finally {
      setAssigning3PL(false);
    }
  };

  // Recall order from 3PL Partner
  const recallOrderFrom3PL = async () => {
    setShowRecallModal(false);
    setRecalling3PL(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${API_URL}/weborders/${order?._id}/recall-from-3pl`,
        { reason: "Recalled by vendor" },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.data.success) {
        toast.success(response.data.message || "Order recalled successfully!");
        dispatch(getOrderDetailsToProcess(order?._id));
      } else {
        toast.error(response.data.error?.message || "Failed to recall order");
      }
    } catch (error) {
      console.error("Error recalling from 3PL:", error);
      toast.error(
        error.response?.data?.error?.message || "Failed to recall order from 3PL partner"
      );
    } finally {
      setRecalling3PL(false);
    }
  };

  if (loading) {
    return (
      <Container>
        <Spinner
          animation="border"
          role="status"
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <Alert variant="danger" className="mt-3">
          {error}
        </Alert>
      </Container>
    );
  }

  if (!order || !order.orderItems || order.orderItems.length === 0) {
    return (
      <Container>
        <Alert variant="info" className="mt-3">
          No order details available
        </Alert>
      </Container>
    );
  }

  return (
    <Container fluid className="order-details-container" style={{ fontSize: "0.9rem" }}>
      {/* Healthcare-Specific Warnings */}
      {hasControlledSubstance && (
        <Alert variant="danger" className="mb-3" style={{
          backgroundColor: "#d32f2f",
          color: "white",
          border: "2px solid #b71c1c",
          fontWeight: "600"
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <MdWarning size={30} />
            <div>
              <strong>CONTROLLED SUBSTANCE ALERT</strong>
              <p className="mb-0">This order contains controlled substances. Ensure proper verification and documentation.</p>
            </div>
          </div>
        </Alert>
      )}

      {hasAgeRestriction && (
        <Alert variant="warning" className="mb-3" style={{ border: "2px solid #ff9800" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <MdVerifiedUser size={25} />
            <div>
              <strong>AGE VERIFICATION REQUIRED</strong>
              <p className="mb-0">Customer must be {maxAgeRestriction}+ years old. Verify age before delivery.</p>
            </div>
          </div>
        </Alert>
      )}

      {requiresPrescription && !order?.prescriptionImageUrl && (
        <Alert variant="info" className="mb-3">
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <MdLocalHospital size={25} />
            <div>
              <strong>PRESCRIPTION REQUIRED</strong>
              <p className="mb-0">This order contains items that require a prescription. Prescription not yet provided.</p>
            </div>
          </div>
        </Alert>
      )}

      {requiresPrescription && order?.prescriptionImageUrl && (
        <Alert variant="success" className="mb-3">
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <MdLocalHospital size={25} />
              <div>
                <strong>PRESCRIPTION PROVIDED</strong>
                <p className="mb-0">Customer has uploaded a prescription for this order.</p>
              </div>
            </div>
            <Button
              variant="outline-success"
              size="sm"
              onClick={() => setShowPrescriptionModal(true)}
            >
              View Prescription
            </Button>
          </div>
        </Alert>
      )}

      <Row className="mb-3">
        <Col md="12">
          <Button
            variant="outline-primary"
            onClick={handleBack}
            className="d-flex align-items-center enhanced-button"
            style={{
              background: "linear-gradient(135deg, #E91E63 0%, #c31354 100%)",
              color: "white",
              border: "none",
            }}
          >
            <MdArrowBackIosNew style={{ marginRight: "8px" }} />
            Back to Orders
          </Button>
        </Col>
      </Row>

      <Row>
        <Col md="12">
          <Card className="shadow enhanced-card">
            <Card.Header
              className="gradient-header rod-card-header-inner"
              style={{
                padding: "20px 25px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "none",
                background: "linear-gradient(135deg, #E91E63 0%, #c31354 100%)",
              }}
            >
              <div>
                <Card.Title
                  as="h4"
                  style={{ color: "white", marginBottom: "5px" }}
                >
                  Healthcare Order Details
                </Card.Title>
                <small style={{ color: "#ffc6d9", display: "block" }}>
                  Order #{order?._id}
                </small>
                {hasBranches && order && (
                  <span
                    className="lk-pill"
                    data-location={orderLocationKeyOf(order)}
                    style={{ background: "rgba(255,255,255,0.18)", color: "#ffffff", marginTop: 6 }}
                    title="The branch this order is for"
                  >
                    <i className="fa fa-store" aria-hidden="true" /> {orderLocationName(order, nameOf)}
                  </span>
                )}
                {order?.createdAt && (
                  <small style={{ color: "#ffc6d9", display: "block", marginTop: "2px" }}>
                    {moment(order.createdAt).format("MMM D, YYYY · h:mm a")}
                  </small>
                )}
              </div>
              <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                <VendorHandoffActions orderId={order?._id} />
                <Button
                  variant="outline-light"
                  onClick={handlePrint}
                  className="d-flex align-items-center enhanced-button rod-print-btn"
                  style={{
                    gap: "8px",
                    background: "rgba(255, 255, 255, 0.2)",
                    backdropFilter: "blur(10px)",
                    border: "2px solid rgba(255, 255, 255, 0.3)",
                  }}
                >
                  <MdLocalPrintshop />
                  Print Receipt
                </Button>
              </div>
            </Card.Header>

            <Card.Body>
              {isDataLoaded && order?.orderItems?.length > 0 ? (
                <>
                  <Row>
                    <Col md="6" className="rod-left-col">
                      <div className="section-title">
                        <h5>
                          <MdShoppingCart style={{ marginRight: "8px" }} />
                          Order Items
                        </h5>
                      </div>
                      <OrderLinesTable
                        order={order}
                        lineExtra={(item) => (
                          <>
                            {item.requiresPrescription && <LineTag tone="info">Rx</LineTag>}
                            {item.ageRestriction > 0 && <LineTag tone="warn">{item.ageRestriction}+</LineTag>}
                            {item.controlledSubstance && <LineTag tone="danger">Controlled</LineTag>}
                          </>
                        )}
                      />
                    </Col>

                    <Col md="6" className="rod-right-col">
                      <div className="section-title">
                        <h5>
                          <MdDescription style={{ marginRight: "8px" }} />
                          Order Summary
                        </h5>
                      </div>
                      <Card className="summary-card">
                        <Card.Body>
                          <div className="customer-info">
                            <h6 className="text-muted mb-3" style={{ fontWeight: "500", color: "#E91E63", fontSize: "1rem", display: "flex", alignItems: "center" }}>
                              <MdPerson style={{ marginRight: "8px", fontSize: "30px" }} />
                              Customer Information
                            </h6>
                            <div className="info-item d-flex justify-content-between align-items-center mb-2">
                              <span>Name:</span>
                              <strong>{order?.customerName}</strong>
                            </div>
                            <div className="info-item d-flex justify-content-between align-items-center mb-2">
                              <span>Phone:</span>
                              <ContactAction
                                label="Customer"
                                name={order?.customerName}
                                phone={order?.shippingAddress?.customerNumber || order?.shippingAddress?.recipientPhone}
                                compact
                              />
                            </div>
                            <div className="info-item d-flex justify-content-between align-items-center mb-2">
                              <span>Payment Method:</span>
                              <strong>{order?.paymentMethod}</strong>
                            </div>
                          </div>

                          <div className="price-summary">
                            <h6 className="text-muted mb-3" style={{ fontWeight: "500", color: "#E91E63", fontSize: "1rem" }}>
                              Price Details
                            </h6>
                            <div className="info-item d-flex justify-content-between align-items-center mb-2">
                              <span>Items Total:</span>
                              <strong>
                                Ush {order?.itemsPrice?.toLocaleString()}
                              </strong>
                            </div>
                            <div className="info-item d-flex justify-content-between align-items-center mb-2">
                              <span>Tax:</span>
                              <strong>Ush {order?.taxPrice?.toFixed(2)}</strong>
                            </div>
                            <div
                              className="info-item d-flex justify-content-between align-items-center mb-2"
                              style={{
                                borderTop: "1px dashed #dee2e6",
                                paddingTop: "10px",
                              }}
                            >
                              <span>Total Amount:</span>
                              <strong
                                style={{ color: "#E91E63", fontSize: "1.1em" }}
                              >
                                Ush {order?.totalPrice?.toLocaleString()}
                              </strong>
                            </div>
                          </div>

                          <div className="status-section">
                            <h6 className="text-muted mb-3" style={{ fontWeight: "500", color: "#E91E63", fontSize: "1rem", display: "flex", alignItems: "center" }}>
                              <MdShowChart style={{ marginRight: "8px" }} />
                              Order Status
                            </h6>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <span>Payment Status:</span>
                              <Badge
                                overlap="rectangular"
                                className="status-badge"
                                style={{
                                  ...getPaidBadgeStyle(order?.isPaid),
                                }}
                              >
                                {order?.isPaid ? (
                                  <>
                                    <MdOutlineCreditCard className="me-1" />{" "}
                                    Paid
                                  </>
                                ) : (
                                  <>
                                    <MdOutlineCreditCardOff className="me-1" />{" "}
                                    Unpaid
                                  </>
                                )}
                              </Badge>
                            </div>
                            <div className="d-flex justify-content-between align-items-center">
                              <span>Delivery Status:</span>
                              <Badge
                                overlap="rectangular"
                                className="status-badge"
                                style={{
                                  ...getBadgeStyle(order?.delivery_status),
                                }}
                              >
                                {order?.delivery_status}
                              </Badge>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>

                  <Row className="mt-4">
                    <Col md="6" className="rider-selection-wrapper">
                      {/* Assignment Mode Toggle */}
                      {!order?.riderId && order?.delivery_status === "PROCESSING" && (
                        <div className="mb-3">
                          <Form.Label style={{ color: "#E91E63", fontWeight: "bold" }}>
                            Assignment Type
                          </Form.Label>
                          <div className="d-flex gap-2 align-items-center flex-wrap">
                            <Button
                              variant={assignmentMode === "rider" ? "primary" : "outline-primary"}
                              size="sm"
                              onClick={() => setAssignmentMode("rider")}
                            >
                              Assign to Rider
                            </Button>
                            <Button
                              variant={assignmentMode === "3pl" ? "success" : "outline-success"}
                              size="sm"
                              onClick={() => setAssignmentMode("3pl")}
                            >
                              <MdLocalShipping style={{ marginRight: "5px" }} />
                              Assign to 3PL Partner
                            </Button>
                            <FormControlLabel
                              style={{ margin: 0 }}
                              control={
                                <Switch
                                  checked={autoAssignEnabled}
                                  onChange={(e) => {
                                    const checked = e.target.checked;
                                    setAutoAssignEnabled(checked);
                                    if (checked) handleVendorAutoAssign();
                                  }}
                                  disabled={(autoAssigning) || !ordersGate.allowed}
                                  title={ordersGate.title}
                                  color="default"
                                  size="small"
                                />
                              }
                              label={
                                <span style={{ fontSize: "13px", fontWeight: 500, color: "#b45309" }}>
                                  {autoAssigning ? (
                                    <><Spinner size="sm" animation="border" className="me-1" style={{ width: "12px", height: "12px" }} />Finding rider…</>
                                  ) : (
                                    <>⚡ Auto-Assign My Riders</>
                                  )}
                                </span>
                              }
                            />
                          </div>
                        </div>
                      )}

                      {/* Show 3PL Partner Assignment if in PENDING_3PL status */}
                      {order?.delivery_status === "PENDING_3PL" && (
                        <Alert
                          style={{
                            backgroundColor: "rgba(233, 30, 99, 0.95)",
                            color: "white",
                            borderRadius: "12px",
                            padding: "16px 20px"
                          }}
                          className="mb-3"
                        >
                          <div className="d-flex justify-content-between align-items-start">
                            <div>
                              <div className="d-flex align-items-center mb-2">
                                <MdLocalShipping style={{ marginRight: "8px", fontSize: "20px" }} />
                                <strong style={{ fontSize: "15px" }}>Pending 3PL Assignment</strong>
                              </div>
                              <div style={{ opacity: 0.9, fontSize: "13px", lineHeight: 1.5 }}>
                                Order sent to: <strong>{order?.assignmentDetails?.partnerId?.companyName || "Unknown"}</strong>
                                <br />
                                Waiting for 3PL to assign a rider.
                              </div>
                            </div>
                            <Button
                              variant="outline-danger"
                              size="sm"
                              style={{
                                borderRadius: "8px",
                                padding: "8px 16px",
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                fontWeight: "500",
                                borderWidth: "2px",
                                backgroundColor: "rgba(220, 38, 38, 0.1)",
                                borderColor: "#dc2626",
                                color: "#fff"
                              }}
                              onClick={() => setShowRecallModal(true)}
                              disabled={(recalling3PL) || !ordersGate.allowed}
                              title={ordersGate.title}
                            >
                              {recalling3PL ? (
                                <>
                                  <Spinner animation="border" size="sm" />
                                  Recalling...
                                </>
                              ) : (
                                <>
                                  <MdUndo style={{ fontSize: "16px" }} />
                                  Recall Order
                                </>
                              )}
                            </Button>
                          </div>
                        </Alert>
                      )}

                      {/* Rider Selection (when mode is 'rider') */}
                      {assignmentMode === "rider" && order?.delivery_status !== "PENDING_3PL" && (
                        <RiderSelectionDropdown
                          order={order}
                          riderId={riderId}
                          setRiderId={setRiderId}
                          loadingRiders={loadingRiders}
                          riders={riders}
                          assignRestaurantOrderToRider={
                            assignHealthcareOrderToRider
                          }
                          elapsedAssignedTime={elapsedAssignedTime}
                          elapsedDispatchedTime={elapsedDispatchedTime}
                          onRiderSelect={(newRiderId) => setRiderId(newRiderId)}
                        />
                      )}

                      {/* 3PL Partner Selection */}
                      {assignmentMode === "3pl" && order?.delivery_status === "PROCESSING" && (
                        <>
                          <ThreePLPartnerDropdown
                            dropoff={order?.shippingAddress?.latLng}
                            selectedPartnerId={selectedPartnerId}
                            onSelectPartner={setSelectedPartnerId}
                            disabled={order?.delivery_status !== "PROCESSING"}
                          />
                          {selectedPartnerId && (
                            <Button
                              variant="success"
                              onClick={assignOrderTo3PLPartner}
                              className="mt-2"
                              style={{
                                width: "100%",
                                backgroundColor: assigning3PL ? "#4caf50" : "#4caf50",
                                borderColor: "#4caf50",
                                color: "white"
                              }}
                              disabled={(!selectedPartnerId || assigning3PL) || !ordersGate.allowed}
                              title={ordersGate.title}
                            >
                              {assigning3PL ? (
                                <>
                                  <Spinner animation="border" size="sm" className="me-2" style={{ color: "white" }} />
                                  <span style={{ color: "white" }}>Assigning...</span>
                                </>
                              ) : (
                                <>
                                  <MdLocalShipping style={{ marginRight: "5px" }} />
                                  Send to 3PL Partner
                                </>
                              )}
                            </Button>
                          )}
                        </>
                      )}

                      {/* Re-assign button (for already assigned orders) */}
                      {order?.delivery_status !== "PROCESSING" &&
                        order?.delivery_status !== "PENDING_3PL" &&
                        !isRiderAssignmentLocked(order) && (
                          <Button
                            disabled={!ordersGate.allowed}
                            title={ordersGate.title}
                            variant="secondary"
                            onClick={handleReassignOrder}
                            className="mt-2"
                            style={{ width: "100%" }}
                          >
                            <>
                              <MdRefresh style={{ marginRight: "5px" }} />
                              Re-assign Order to different Rider!
                            </>
                          </Button>
                        )}
                    </Col>
                    <Col md="6">
                      <Form.Group
                        controlId="formOrderStatus"
                        className="shadow p-3"
                        style={{ boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.2)" }}
                      >
                        <Form.Label
                          style={{ color: "#E91E63", fontWeight: "bold" }}
                        >
                          Update Order Status
                        </Form.Label>
                        <AppSelect block
                          disabled={!ordersGate.allowed}
                          title={ordersGate.title}
                          value={order.delivery_status}
                          onChange={(e) => handleUpdateStatus(e.target.value)}
                        >
                          <option
                            value="PROCESSING"
                            disabled={disabledStatusOptions.PROCESSING}
                          >
                            1. Processing
                          </option>
                          <option
                            value="ASSIGNED"
                            disabled={disabledStatusOptions.ASSIGNED}
                          >
                            2. Assigned
                          </option>
                          <option
                            value="DISPATCHED"
                            disabled={disabledStatusOptions.DISPATCHED}
                          >
                            3. Dispatched
                          </option>
                          <option
                            value="DELIVERED"
                            disabled={disabledStatusOptions.DELIVERED}
                          >
                            4. Delivered
                          </option>
                          <option
                            value="REJECTED"
                            disabled={disabledStatusOptions.REJECTED}
                          >
                            5. Cancel Order
                          </option>
                        </AppSelect>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mt-4">
                    <Col className="d-flex justify-content-end align-items-center rod-action-row">
                      <div
                        style={{
                          cursor: !canCancelOrder ? "not-allowed" : "pointer",
                          backgroundColor: !canCancelOrder
                            ? "#8C1F28"
                            : "transparent",
                          borderRadius: "5px",
                          padding: "2px",
                          marginRight: "5px",
                          width: "160px",
                          height: "40px",
                        }}
                      >
                        <Button
                          variant="danger"
                          onClick={() => setShowCancelModal(true)}
                          className="mr-2"
                          disabled={(!canCancelOrder) || !ordersGate.allowed}
                          title={ordersGate.title}
                          style={{
                            backgroundColor: !canCancelOrder
                              ? "transparent"
                              : "red",
                            color: !canCancelOrder ? "white" : "white",
                            border: "none",
                            fontSize: "14px",
                            width: "100%",
                            height: "100%",
                            padding: "6px",
                            boxShadow: "0 3px 8px rgba(0,0,0,0.9)",
                          }}
                        >
                          <MdCancel
                            style={{
                              fontSize: "20px",
                              justifyContent: "center",
                              alignItems: "center",
                              marginRight: "5px",
                            }}
                          />
                          Cancel Order
                        </Button>
                      </div>
                      {/* components/Orders/ContactAction: a real tel: link on a
                          phone, copy on a desktop. The old button only raised a
                          toast with the number. */}
                      <ContactAction
                        label="Customer"
                        name={order?.customerName}
                        phone={order?.shippingAddress?.customerNumber || order?.shippingAddress?.recipientPhone}
                        style={{ marginRight: 5 }}
                      />
                    </Col>
                  </Row>

                  <Row className="mt-4">
                    <Col md="12">
                      {/* What to do next, and who the order is waiting on.
                          Shared with the restaurant, retailer and brand
                          pages. */}
                      <OrderNextStep order={order} style={{ marginBottom: "12px" }} />
                      <ProgressBar
                        now={getProgress()}
                        label={`${getProgress()}%`}
                        className="enhanced-progress"
                        variant={
                          order?.delivery_status === "DELIVERED"
                            ? "success"
                            : undefined
                        }
                      />
                    </Col>
                  </Row>

                  <Row className="mt-4">
                    <Col md="12" className="d-flex justify-content-between rod-dispatch-row">
                      <div
                        style={{
                          cursor:
                            !canVendorDispatch(order)
                              ? "not-allowed"
                              : "pointer",
                          backgroundColor:
                            !canVendorDispatch(order)
                              ? "#4B4952"
                              : "transparent",
                          borderRadius: "5px",
                          padding: "2px",
                        }}
                      >
                        <Button
                          variant="warning"
                          onClick={handleDispatchHealthcareOrder}
                          disabled={(!canVendorDispatch(order)) || !ordersGate.allowed}
                          title={ordersGate.title}
                          style={{
                            backgroundColor:
                              !canVendorDispatch(order)
                                ? "transparent"
                                : "orange",
                            color:
                              !canVendorDispatch(order)
                                ? "white"
                                : "black",
                            border: "none",
                            fontSize: "14px",
                            boxShadow: "0 2px 5px rgb(236, 234, 232)",
                          }}
                        >
                          Dispatch Order
                        </Button>
                      </div>
                      <div
                        style={{
                          cursor:
                            !canVendorMarkDelivered(order)
                              ? "not-allowed"
                              : "pointer",
                          backgroundColor:
                            !canVendorMarkDelivered(order)
                              ? "green"
                              : "transparent",
                          borderRadius: "5px",
                          padding: "2px",
                        }}
                      >
                        <Button
                          variant="success"
                          onClick={handleDeliverHealthcareOrder}
                          disabled={(!canVendorMarkDelivered(order)) || !ordersGate.allowed}
                          title={ordersGate.title}
                          style={{
                            backgroundColor:
                              !canVendorMarkDelivered(order)
                                ? "transparent"
                                : "green",
                            color:
                              !canVendorMarkDelivered(order)
                                ? "white"
                                : "black",
                            border: "none",
                            fontSize: "14px",
                            boxShadow: "0 2px 5px rgb(236, 234, 232)",
                          }}
                        >
                          Mark as Delivered
                        </Button>
                      </div>
                      <div
                        style={{
                          cursor: order?.isPaid ? "not-allowed" : "pointer",
                        }}
                      >
                        <FormControlLabel
                          control={
                            <IOSSwitch
                              checked={!!order?.isPaid}
                              onChange={handleMarkAsPaid}
                              color="primary"
                              disabled={(order?.delivery_status !== "DELIVERED" ||
                                !!order?.isPaid) || !ordersGate.allowed}
                              title={ordersGate.title}
                            />
                          }
                          label={order?.isPaid ? "Paid" : "Mark as Paid"}
                        />
                      </div>
                    </Col>
                  </Row>
                </>
              ) : (
                <div className="text-center py-5">
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Cancel Order Modal */}
      <Modal show={showCancelModal} onHide={() => { setShowCancelModal(false); cancelReason.reset(); }}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Cancellation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to cancel this order?
          <CancelOrderFields state={cancelReason} isPaid={!!order?.isPaid} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCancelModal(false)}>
            Close
          </Button>
          <Button variant="danger" onClick={handleCancelOrder}>
            Cancel Order
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Recall from 3PL Confirmation Modal */}
      <Modal show={showRecallModal} onHide={() => setShowRecallModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Recall Order from 3PL</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to recall this order from{" "}
          <strong>{order?.assignmentDetails?.partnerId?.companyName || "the 3PL partner"}</strong>?
          <br />
          <small className="text-muted">
            The order will be removed from the 3PL partner's queue and returned to PROCESSING status.
          </small>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowRecallModal(false)}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={recallOrderFrom3PL}
            disabled={recalling3PL}
          >
            {recalling3PL ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Recalling...
              </>
            ) : (
              "Recall Order"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Prescription Image Modal */}
      <Modal show={showPrescriptionModal} onHide={() => setShowPrescriptionModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Prescription Image</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {order?.prescriptionImageUrl ? (
            <img
              src={order.prescriptionImageUrl}
              alt="Prescription"
              style={{ maxWidth: "100%", maxHeight: "600px" }}
            />
          ) : (
            <p>No prescription image available</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowPrescriptionModal(false)}>
            Close
          </Button>
          {order?.prescriptionImageUrl && (
            <Button
              variant="primary"
              onClick={() => window.open(order.prescriptionImageUrl, "_blank")}
            >
              Open in New Tab
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      {/* Delivery Distance Information (if available) */}
      {order &&
        order.orderItems &&
        order.orderItems[0] &&
        order.orderItems[0].vendorId && (
          <Card className="shadow-sm mt-4 distance-info-card">
            <Card.Header
              style={{
                background: "linear-gradient(135deg, #E91E63 0%, #c31354 100%)",
                color: "white",
                padding: "1.5rem",
              }}
            >
              <h4 style={{ margin: 0, display: "flex", alignItems: "center" }}>
                <MdLocationOn style={{ marginRight: "10px", fontSize: "24px" }} />
                Delivery Distance Information
              </h4>
            </Card.Header>
            <Card.Body style={{ padding: "1.5rem" }}>
              <Row>
                <Col md={6}>
                  <div className="info-box">
                    <h5
                      style={{
                        color: "#E91E63",
                        marginBottom: "1.2rem",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <MdStorefront
                        style={{ marginRight: "8px", fontSize: "20px" }}
                      />
                      Healthcare Provider Details
                    </h5>
                    <div style={{ marginBottom: "1rem" }}>
                      <strong style={{ color: "#495057" }}>Name:</strong>
                      <p className="info-field" style={{ margin: "4px 0 12px 0" }}>
                        {order?.orderItems[0]?.vendorId?.businessName}
                      </p>
                    </div>
                    <div style={{ marginBottom: "1rem" }}>
                      <strong style={{ color: "#495057" }}>Address:</strong>
                      <p className="info-field" style={{ margin: "4px 0 12px 0" }}>
                        {order?.orderItems[0]?.vendorId?.businessAddress}
                      </p>
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="info-box">
                    <h5
                      style={{
                        color: "#E91E63",
                        marginBottom: "1.2rem",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <MdAnalytics
                        style={{ marginRight: "8px", fontSize: "20px" }}
                      />
                      Distance Analysis
                    </h5>
                    {/* The same drop-off block as the admin order page:
                        place name, precision chip, Show map, Send pin,
                        Copy pin. This page only showed the precision chip. */}
                    {Number.isFinite(Number(order?.shippingAddress?.latLng?.lat)) &&
                      Number.isFinite(Number(order?.shippingAddress?.latLng?.lng)) && (
                        <div style={{ marginBottom: 10 }}>
                          <DropoffMap
                            lat={order.shippingAddress.latLng.lat}
                            lng={order.shippingAddress.latLng.lng}
                            address={getShippingAddressText(order?.shippingAddress, "")}
                            shippingAddress={order?.shippingAddress}
                            orderRef={order?.order_number || order?._id}
                            rider={assignedRider || order?.riderId}
                            country={order?.country}
                          />
                        </div>
                      )}
                    {!order?.shippingAddress?.latLng ? (
                      <div
                        style={{
                          fontSize: 13,
                          color: "#6b7280",
                          background: "#f8f9fa",
                          border: "1px dashed #d1d5db",
                          borderRadius: 8,
                          padding: "12px 14px",
                          lineHeight: 1.5,
                        }}
                      >
                        <MdLocationOn style={{ marginRight: 6, color: "#E91E63", verticalAlign: "-2px" }} />
                        {Number(order?.distanceKm) > 0
                          ? `Distance to customer: ${Number(order.distanceKm).toFixed(2)} km (from the order's saved delivery distance). A precise map route isn't shown because this delivery address has no saved coordinates.`
                          : "Distance unavailable — this delivery address has no saved coordinates, so the route can't be measured. The delivery fee was set from the zone minimum. New orders capture the customer's coordinates at checkout."}
                      </div>
                    ) : (
                      <>
                        <div style={{ marginBottom: "1rem" }}>
                          <strong style={{ color: "#495057", fontSize: "12px", fontWeight: 600 }}>
                            Distance to Customer:
                          </strong>
                          <div
                            className="info-field"
                            style={{
                              margin: "4px 0",
                              display: "flex",
                              alignItems: "center",
                              fontSize: "13px",
                            }}
                          >
                            <MdLocationOn style={{ marginRight: "8px", color: "#E91E63" }} />
                            {(() => {
                              const storeLat = order?.orderItems[0]?.vendorId?.latitude;
                              const storeLng = order?.orderItems[0]?.vendorId?.longitude;
                              const custLat = order?.shippingAddress?.latLng?.lat;
                              const custLng = order?.shippingAddress?.latLng?.lng;

                              const hasServerKm = Number(order?.distanceKm) > 0;
                              if (
                                !hasServerKm &&
                                (!storeLat || !storeLng || !custLat || !custLng)
                              ) {
                                return "-- km";
                              }

                              const km = hasServerKm
                                ? Number(order.distanceKm)
                                : Number(
                                    calculateDistance(
                                      storeLat,
                                      storeLng,
                                      custLat,
                                      custLng
                                    )
                                  );

                              return (
                                <>
                                  {`${km.toFixed(2)} km`}
                                  <span
                                    style={{
                                      marginLeft: 6,
                                      fontSize: "10px",
                                      color: "#9ca3af",
                                      fontWeight: 500,
                                    }}
                                  >
                                    {hasServerKm ? "road" : "approx"}
                                  </span>
                                </>
                              );
                            })()}
                          </div>
                        </div>
                        {(() => {
                          const storeLat = order?.orderItems[0]?.vendorId?.latitude;
                          const storeLng = order?.orderItems[0]?.vendorId?.longitude;
                          const custLat = order?.shippingAddress?.latLng?.lat;
                          const custLng = order?.shippingAddress?.latLng?.lng;
                          const km =
                            Number(order?.distanceKm) > 0
                              ? Number(order.distanceKm)
                              : Number(
                                  calculateDistance(
                                    storeLat,
                                    storeLng,
                                    custLat,
                                    custLng
                                  )
                                );
                          const zoneRadius =
                            order?.orderItems[0]?.vendorId?.deliveryZoneRadius;

                          return zoneRadius && km > zoneRadius ? (
                            <Alert
                              variant="warning"
                              style={{
                                borderRadius: "8px",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              <MdWarning size={20} />
                              {`Customer is outside the provider's delivery zone (${zoneRadius}km)`}
                            </Alert>
                          ) : null;
                        })()}
                        <div className="mt-4">
                          <Button
                            variant="info"
                            className="enhanced-button"
                            style={{
                              background: "linear-gradient(135deg,rgb(28, 64, 25) 0%, #45a29e 100%)",
                              color: "white",
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              width: "100%",
                              justifyContent: "center",
                            }}
                            onClick={() => setShowMapModal(true)}
                          >
                            <MdMap size={20} />
                            View Route on Map
                          </Button>
                        </div>
                      </>
                    )}
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        )}

      {/* Map Modal */}
      <Modal
        show={showMapModal}
        onHide={() => setShowMapModal(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delivery Route Map</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "70vh", padding: 0 }}>
          {order?.shippingAddress?.latLng && order?.orderItems[0]?.vendorId && (
            <iframe
              title="Delivery Route"
              width="100%"
              height="100%"
              frameBorder="0"
              style={{ border: 0 }}
              src={`https://www.google.com/maps/embed/v1/directions?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY
                }
                &origin=${order?.orderItems[0]?.vendorId?.latitude || 0
                },${order?.orderItems[0]?.vendorId?.longitude || 0
                }
                &destination=${order?.shippingAddress?.latLng?.lat},${order?.shippingAddress?.latLng?.lng
                }
                &mode=driving`}
              allowFullScreen
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowMapModal(false)}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              const storeLoc = `${order?.orderItems[0]?.vendorId?.latitude || 0
                },${order?.orderItems[0]?.vendorId?.longitude || 0
                }`;
              const customerLoc = `${order?.shippingAddress?.latLng?.lat},${order?.shippingAddress?.latLng?.lng}`;
              window.open(
                `https://www.google.com/maps/dir/${storeLoc}/${customerLoc}`,
                "_blank"
              );
            }}
          >
            Open in Google Maps
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default HealthcareVendorOrderDetails;

